import React, { useEffect, useState, createContext, useContext } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import DetalleComunicado from './DetalleComunicado';
import UtilsListas from '../Tools/UtilsListas';
import { ReactSession } from "react-client-session";
import addButton from "../../assets/addButon.png"
import NuevoComunicado from './NuevoComunicado';
import MisComunicados from './MisComunicados';
import NuevosComunicados from './NuevosComunicados';
import Modal from 'react-bootstrap/Modal';
import VerificarPermisos from '../Tools/VerificarPermisos';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;
export const Context = createContext();

function PrincipalComunicados(props) {
  const { loading, setLoading } = useContext(ContextGloball);
  const { regional, tipo } = props;
  const [estadoC, setEstadoC] = useState('hola');
  const [dateIni, setDateIni] = useState('');
  const [dateFin, setDateFin] = useState('');
  const [comunicados, setComunicados] = useState([]);
  const [elegido, setElegido] = useState(4);
  const [selectComu, setSelectComu] = useState({});
  const [hayC, setHayC] = useState(false);
  const [actualizar, setActualizar] = useState(0);
  const [modalDetalle, setModalDetalle] = useState(false);
  const [modalNuevoComunicado, setModalNuevoComunicado] = useState(false);
  async function send(tipo, mensage, elegido) {
    var idUsuario = ReactSession.get('idSession');
    var regional = ReactSession.get('regional');
    var empresaSucursal = ReactSession.get('empresaSucursal');
    await fetch(`${server}/comunicados/lista/respuesta`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        vId: 0, idUsuario, regional, mensage, empresaSucursal, elegido, tipo,
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          setModalDetalle(true);
          setActualizar(actualizar + 1)
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => console.log(err));
  }
  const verDetalles = async (e) => {
    console.log(e);
    var id = e.target.id;
    console.log(id)
    if (id !== undefined) {
      var dato = UtilsListas.getElemento(comunicados, id);
      setSelectComu(dato);
      await send('VIS', '', id);
    }
  };
  const formatoFecha = (fecha) => {
    let date = new Date(Date.parse(fecha));
    return `${date.getDate()}/${date.toLocaleString('default', { month: 'long' })}/${date.getFullYear()}`;
  }
  useEffect(() => {
    if (dateIni === '' && dateFin === '') {
      var fecha = new Date()
      setDateFin(fecha.toISOString().substring(0, 10));
      var fechaI = new Date(fecha.setDate(fecha.getDate() - 5))
      setDateIni(fechaI.toISOString().substring(0, 10));
    }
    if (elegido !== 0) {
      setElegido(4);
      setLoading(true);
    }
    fetch(`${server}/comunicados/lista`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        dateIni, dateFin, regional, info: JSON.parse(localStorage.getItem("info")), tipo
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          setComunicados(data.ok);
          setLoading(false);
          if ((data.ok.length) !== 0) {
            setHayC(true);
          } else {
            setHayC(false);
          }
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => console.log(err));
  }, [dateIni, dateFin, regional, tipo])
  return (
    <Context.Provider
      value={{
        estadoC,
        setEstadoC
      }}
    >{(elegido === 0 || elegido === 3 || elegido === 4) &&
      <nav className="navbar navbar-expand navbar-dark bg-dark bg-gradient m-0 p-0">
        <div className='text-light fw-bold px-2 fs-4 d-none'>{tipo === 'C' ? 'Comunicados ' : 'Mensajeria '}</div>
        <div className="container-fluid">
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <i className="fa-solid fa-list-ul text-white"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-lg-0">
              <li className={elegido === 3 ? " rounded-3 nav-item selected bg-gradient m-1 border border-light" : "nav-item rounded-3 bg-gradient m-1 border border-light"}
                onClick={() => setElegido(3)} style={{ height: "29px" }}>
                <a className="nav-link active m-1 p-0" style={{ height: "25px" }}><i className="fa-solid fa-paper-plane"></i> <span className='d-none d-sm-inline'>Enviados</span></a>
              </li>
              <li className={elegido === 0 ? " rounded-3 nav-item selected bg-gradient m-1 border border-light" : "nav-item rounded-3 bg-gradient m-1 border border-light"}
                onClick={() => setElegido(0)} style={{ height: "29px" }}>
                <a className="nav-link active m-1 p-0" style={{ height: "25px" }}><i className="fa-solid fa-eye"></i> <span className='d-none d-sm-inline'>Leidos</span></a>
              </li>
              <li className={elegido === 4 ? " rounded-3 nav-item selected bg-gradient m-1 border border-light" : "nav-item rounded-3 bg-gradient m-1 border border-light"}
                onClick={() => setElegido(4)} style={{ height: "29px" }}>
                <a className="nav-link active m-1 p-0" style={{ height: "25px" }}><i className="fa-solid fa-eye-slash"></i> <span className='d-none d-sm-inline'>No Leidos</span></a>
              </li>
            </ul>
          </div>
        </div>
      </nav>}
      {elegido === 0 &&
        <div>
          <div className='container-fluid bg-secondary text-white py-1'>
            <div className="btn-group" role="group" aria-label="Basic example">
              <div className='row row-cols-sm-1 row-cols-md-2 g-1'>
                <div className='col col-sm-6 col-md-6'>
                  <div className="input-group my-auto" style={{ height: "25px", width: "210px" }}>
                    <span className="input-group-text bg-secondary bg-gradient text-light" style={{ height: "25px" }}>Inicio</span>
                    <input type="date" className="form-control"
                      aria-describedby="basic-addon1" style={{ height: "25px" }}
                      value={dateIni} onChange={(e) => { setActualizar(!actualizar); setLoading(true); setDateIni(e.target.value); }} />
                  </div>
                </div>
                <div className='col col-sm-6 col-md-6'>
                  <div className="input-group my-auto" style={{ height: "25px", width: "210px" }}>
                    <span className="input-group-text bg-secondary bg-gradient text-light" style={{ height: "25px" }}>Fin</span>
                    <input type="date" className="form-control"
                      aria-describedby="basic-addon1" style={{ height: "25px" }}
                      value={dateFin} onChange={(e) => { setActualizar(!actualizar); setLoading(true); setDateFin(e.target.value); }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={loading ? 'd-none' : ''}>
            <div className={hayC ? 'd-none' : 'card bg-warning text-center'}>
              <div className='card-header bg-gradient fw-bold'>
                <i className="fa-solid fa-circle-info"></i> No hay comunicados
              </div>
              <div className='card-body'>
                En los rangos de fechas actuales, no se tiene comunicados ...
              </div>
            </div>
            <div className={hayC ? 'table-responsive ' : 'd-none'}>
              <table className="table table-striped table-bordered table-sm table-hover">
                <thead className='bg-secondary bg-gradient text-center fw-bold text-light'>
                  <tr>
                    <th scope="col">FECHA</th>
                    <th scope="col">DE:</th>
                    <th scope="col">Descripción</th>
                    <th scope="col">Mas</th>
                  </tr>
                </thead>
                <tbody>
                  {comunicados.map((item, index) => {
                    return (
                      <tr key={index} className="my-auto">
                        <th className="col-1">{formatoFecha(item.FECHA)}</th>
                        <td className='col-4'>
                          <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                            {UtilsBufer.getFotoCard(item.FOTO, 40)}
                            <div className='ps-2 my-auto d-none d-sm-inline'>
                              <div className="cargoHeader fw-bold">{item.COLABORADOR}</div>
                              <div className='cargoHeader '>{item.CARGO}</div>
                            </div>
                          </div>
                        </td>
                        <td>{item.DESCRIPCION}</td>
                        <td>
                          <a className='btn btn-transparent fs-4 m-0 p-0' id={item.ID_COMUNICADO}
                            onClick={verDetalles}>
                            <i id={item.ID_COMUNICADO} className="bi bi-eye-fill"></i>
                          </a>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>}
      {VerificarPermisos.validarPermiso('16') &&
        <div className={`fixed-bottom text-end m-2`}>
          <img src={addButton} height='50' onClick={() => setModalNuevoComunicado(true)}></img>
        </div>}
      <Modal show={modalDetalle} onHide={() => setModalDetalle(false)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName='bg-secondary bg-gradient'
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton closeVariant='white'>
          <Modal.Title bsPrefix='text-light' id="contained-modal-title-vcenter">
            {`${tipo === 'C' ? 'Comunicado' : 'Mensaje'}: ${selectComu.ID_COMUNICADO} - ${selectComu.DESCRIPCION}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalDetalle === true &&
            <DetalleComunicado
              selectComu={selectComu} regional={regional} tipo={tipo} />
          }
        </Modal.Body>
      </Modal>
      <Modal show={modalNuevoComunicado} onHide={() => setModalNuevoComunicado(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName='modalNuevoC'
        backdrop="static"
        keyboard={false}>
        <Modal.Body>
          {modalNuevoComunicado === true &&
            <NuevoComunicado regional={regional} cerrarModal={setModalNuevoComunicado} tipo={tipo} />
          }
        </Modal.Body>
      </Modal>
      {elegido === 3 &&
        <MisComunicados regional={regional}
          setElegido={setElegido}
          setSelectComu={setSelectComu}
          tipo={tipo} setModalNuevoComunicado={setModalNuevoComunicado} setModalDetalle={setModalDetalle} />
      }
      {elegido === 4 &&
        <NuevosComunicados regional={regional} actualizar={actualizar} setSelectComu={setSelectComu}
          tipo={tipo} setModalNuevoComunicado={setModalNuevoComunicado} setModalDetalle={setModalDetalle} />
      }
    </Context.Provider>
  )
}

export default PrincipalComunicados
